import { render } from "./Passwords.vue?vue&type=template&id=d3048986&scoped=true&ts=true"
import script from "./Passwords.vue?vue&type=script&lang=ts"
export * from "./Passwords.vue?vue&type=script&lang=ts"

import "./Passwords.vue?vue&type=style&index=0&id=d3048986&scoped=true&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3048986"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QBtn});
